/* Calm & Dry landing page: carousels dots, single-open accordions, subscribe toggle, buy-now-to-checkout. */
(function () {
  if (window.__calmdryInit) return;
  window.__calmdryInit = true;

  function initRails() {
    document.querySelectorAll('.cd-lp [data-cd-rail]').forEach(function (rail) {
      var dots = rail.parentElement.querySelector('[data-cd-dots]');
      if (!dots || dots.childElementCount) return;
      var items = rail.children;
      for (var i = 0; i < items.length; i++) dots.appendChild(document.createElement('span'));
      var update = function () {
        var w = items[0] ? items[0].getBoundingClientRect().width + 14 : 1;
        var n = Math.round(rail.scrollLeft / w);
        Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-on', j === n); });
      };
      rail.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  function initAccordions() {
    document.querySelectorAll('.cd-lp [data-cd-acc-group]').forEach(function (group) {
      group.querySelectorAll('details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          group.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  function initOffer() {
    document.querySelectorAll('.cd-lp [data-cd-offer]').forEach(function (offer) {
      if (offer.__cdInit) return;
      offer.__cdInit = true;
      var planId = offer.getAttribute('data-plan');
      var sw = offer.querySelector('[data-cd-switch]');
      var err = offer.querySelector('[data-cd-err]');
      var subscribed = function () { return !!(sw && sw.getAttribute('aria-checked') === 'true'); };

      if (sw) {
        sw.addEventListener('click', function () {
          var on = !subscribed();
          sw.setAttribute('aria-checked', on ? 'true' : 'false');
          offer.querySelectorAll('[data-once]').forEach(function (el) { el.hidden = on; });
          offer.querySelectorAll('[data-sub]').forEach(function (el) { el.hidden = !on; });
        });
      }

      offer.querySelectorAll('form[data-cd-buy]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('button[type=submit]');
          var item = { id: Number(form.elements.id.value), quantity: 1 };
          if (planId && subscribed()) item.selling_plan = Number(planId);
          btn.disabled = true;
          if (err) err.classList.remove('is-on');
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = '/checkout';
          }).catch(function () {
            btn.disabled = false;
            if (err) err.classList.add('is-on');
          });
        });
      });
    });
  }

  function init() { initRails(); initAccordions(); initOffer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { window.__calmdryInit = true; init(); });
})();
